import React from 'react';
import Form from 'devextreme-react/form';
import{userServices} from "../../services/user.service";
import { Button, TextBox } from 'devextreme-react';
import notify from 'devextreme/ui/notify';
import { Popup } from 'devextreme-react/popup';
import { twilioServices } from '../../services/twilio.service';
import { parsePhoneNumber } from 'react-phone-number-input';
import { dropboxServices } from '../../services/dropbox.service';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const formItems = [{
    itemType: 'group',
    cssClass: 'first-group',
    colCount: 1,
    items: [{
        dataField: 'userName',
        editorOptions: { 
            disabled: true
        },
        
    }, {
        dataField: 'roles',
        editorOptions: {
            disabled: true
        }
    }, {
        itemType: "group",
        caption: "Password",
        items: [{
            dataField: 'currentPassword',
            editorOptions: {
                mode: 'password',
                placeholder:'Enter your current password'
            }
        }, {
            dataField: 'newPassword',
            editorOptions: {
                mode: 'password',
                placeholder:'Enter new password',
            }
        }, {
            dataField: 'confirmPassword',
            editorOptions: {
                mode: 'password',
                placeholder:'Enter confirm password',
            }
        }]
    }, 
    {
        itemType: "group",
        caption: " ",
        items: []
    }, {
        dataField: 'email'
    }, {
        dataField: 'fullName'
    // }, {
    //     dataField: 'spireAPIKey'
    },
    {
        dataField: 'phoneNumber',
        editorOptions: {
            mask: '+1 (X00) 000-0000',
            maskRules: {
                X: /[02-9]/
            },
            useMaskedValue: true,
            maskInvalidMessage: 'The phone must have a correct USA phone format'
        }
    }]
}];

export class UserProfile extends React.Component {
    constructor(props) {
        super(props);

        var user, dropboxUser;
        this.state = {user, dropboxUser, dropboxStatus:"Connect", phoneVerificationStatus:"Unverified", showVerificationPhoneNumber:true, popupVisible: false, verificationCode:"", enteredCode:""};
        this.onClick = this.onClick.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.hidePopup = this.hidePopup.bind(this);
        this.onVerifyPhoneNumberClick = this.onVerifyPhoneNumberClick.bind(this);
        this.onVerifyClick = this.onVerifyClick.bind(this);
        this.onDropboxClick = this.onDropboxClick.bind(this);
        this.valueChanged = this.valueChanged.bind(this);

        userServices.getCurrentUser().then(
            data=>{
                this.setState({ user: data});
                this.setState({phoneNumber:data.phoneNumber});

                const phoneNumber = data.phoneNumber!=null? parsePhoneNumber(data.phoneNumber): '';
                if (phoneNumber) {
                    this.setState({  country : phoneNumber.country});
                }

                if(data.phoneNumberConfirmed===true){
                    this.setState({ phoneVerificationStatus: "Verified", showVerificationPhoneNumber:false});
                }else
                {
                    confirmAlert({
                        title: 'Verify phone number',
                        message: 'Would you like to verify your phone number now?',
                        buttons: [
                          {
                            label: 'Yes',
                            onClick: () => {this.onVerifyPhoneNumberClick(null);}
                          },
                          {
                            label: 'No'
                          }
                        ]
                    });                   
                }

                var search = new URLSearchParams(this.props.location.search);
                var state = search.get("state");
                var code = search.get("code");
                if(code){
                    dropboxServices.auth(code, state, this.state.user.id).then(
                        response=>{
                            dropboxServices.callSpinriseCamera(response).then(
                                result=>{
                                    notify({position:'top right', message:"Call Spinrise Camera successfully.", type:'success',maxWidth:200});
                                }, 
                                error=>{
                                    notify({position:'top right', message:"Failed: cannot call Spinrise Camera.", type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                                }
                            );

                            notify({position:'top right', message:"This account has been connected from Dropbox.", type:'success',maxWidth:200});
                            this.setState({ dropboxStatus: "Disconnect"});
                            this.props.history.push('/UserProfile');
                        }, 
                        error=>{
                            notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                        }
                    );
                }


                dropboxServices.getDropboxUserByUserId(data.id).then(
                    response=>{
                        this.setState({dropboxUser:response});
                        if(response.accessToken)
                        {
                            this.setState({dropboxStatus:"Disconnect"});
                        }
                        else
                        {
                            this.setState({dropboxStatus:"Connect"});
                        }
                    }, 
                    error=>{
                        this.setState({dropboxStatus:"Connect"});
                    }
                );

            },
            error=>{
                notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
            }
        );

        this.setForm = (ref) => {
            if(ref!=null)
            {
                this.form = ref.instance;
                //this.form.itemOption('Password', 'visible', false);
                //this.form.itemOption('-Password-', 'visible', false);
                //this.form.itemOption('newPassword', 'visible', false);
                //this.form.itemOption('confirmPassword', 'visible', false);
            }
        };
    }
    
    showPopup(){
        this.setState({popupVisible: true});
    }
    hidePopup(){
        this.setState({popupVisible: false});
    }

    valueChanged(data) {
        this.setState({enteredCode: data.value});
    }

    onVerifyClick(e){
        if(this.state.enteredCode===this.state.verificationCode){
            this.setState({phoneVerificationStatus:"Verified", showVerificationPhoneNumber:false});
            //update user set PhoneNumberConfirmed = true
            var formData = this.form.option("formData");
            if(formData.newPassword===''){
                formData.newPassword=null;
                formData.confirmPassword=null;
            }
            formData.phoneNumberConfirmed=true;
            formData.isVerifiedPhoneNumber=true;

            userServices.update(formData).then(
                response=>{
                    notify({position:'top right', message:"Your phone number has been verified.", type:'success',maxWidth:200});
                    //hide popup
                    this.setState({popupVisible: false});
                }, 
                error=>{
                    notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                }
            );
        }
        else{
            notify({position:'top right', message:"Verification code is not correct.", type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
            this.setState({showVerificationPhoneNumber:true});
        }

    }

    onDropboxClick(e){
        if(this.state.dropboxStatus==="Connect")
        {
            dropboxServices.connect(this.state.user.id).then(
                data=>{
                    //redirect to dropbox
                    window.location.href =data;
                },
                error=>{
                    notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                }
            );
        }
        else
        {
            dropboxServices.disconnect(this.state.user.id).then(
                data=>{
                    notify({position:'top right', message:"This account has been disconnected from Dropbox.", type:'success',maxWidth:200});
                    this.setState({ dropboxStatus: "Connect"});
                },
                error=>{
                    notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                }
            );
        }
    }

    onVerifyPhoneNumberClick(e){
        var formData = this.form.option("formData");
        if(formData.phoneNumber !==null && formData.phoneNumber.length>0)
        {
            var min=9999;
            var max=99999;
            var randomVerifyCode =Math.floor(Math.random() * (max - min + 1) ) + min;
            this.setState({verificationCode:randomVerifyCode.toString()});
            
            //update SMSVerificationCode of the user
            if(formData.newPassword===''){
                formData.newPassword=null;
                formData.confirmPassword=null;
            }
            formData.sMSVerificationCode = randomVerifyCode.toString();
            
            userServices.update(formData).then(
                response=>{
                    //Send SMS verification code to user phone number
                    var messageBody="Spinrise phone number verification code is "+randomVerifyCode;

                    twilioServices.sendVerifySMS(formData.phoneNumber, messageBody).then(
                        data=>{
                        if(data ===true){
                            notify({position:'top right', message:"An SMS has been sent to your mobile phone.", type:'success',maxWidth:200});
                            this.showPopup();
                        }
                        else if(data ===false){
                            notify({position:'top right', message:"Phone number is invalid.", type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                        }
                        },
                        error=>{
                        notify({position:'top right', message:"Failed: cannot send verify SMS. "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                        }
                    );
                }, 
                error=>{
                    notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                }
            );
        }
        else
        {
            notify({position:'top right', message:"Please enter phone number.", type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
        }
    }

    onClick(e) {
        var formData = this.form.option("formData");
        
        if(formData.newPassword===''){
            formData.newPassword=null;
            formData.confirmPassword=null;
        }
        if(formData.newPassword!==formData.confirmPassword){
            notify({position:'top right', message:"Password and Confirm Password do not match",type:'error',maxWidth:500, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
        }
        else{
            //formData.roles = this.ddlRoles.option("displayValue");
                    
            userServices.update(formData).then(
                response=>{
                    notify({position:'top right', message:'Updated successfully',type:'success',maxWidth:200});
                }, 
                error=>{
                    notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                }
            );
        }
    }
      
    render() {
        const { user, phoneVerificationStatus, showVerificationPhoneNumber,country,phoneNumber, dropboxStatus} = this.state;
        return (
            <div>
                <h4>User Profile</h4>
                <div className='userProfileForm'>
                    <Form formData={user} items={formItems} ref={this.setForm}/>
                    {/* <div style={{paddingTop:"10px"}}>
                        <b style={{fontSize:"12px", paddingRight:"10px"}}>Spire API Key:</b>
                        
                    </div> */}
                    {/* <div style={{paddingTop:"10px"}}>
                        <b style={{fontSize:"12px", paddingRight:"10px"}}>Phone Number:</b>
                        <PhoneInput style={{width:"385px", float:"right"}} 
                            country={country} limitMaxLength={true} value={phoneNumber} onChange={ phoneNumber => this.setState({ phoneNumber }) } />
                    </div>                        */}
                    <div style={{paddingTop: "5px" }}>                        
                        <b><span style={{fontSize:"12px"}}>Phone number status:</span>
                        <span style={{padding:"0 20px"}}>{phoneVerificationStatus}</span></b>
                        <Button
                            key='btnVerifyPhoneNumber'
                            width={180}
                            height={30}
                            text='Send verification code'
                            type='default'
                            stylingMode='contained'
                            onClick={this.onVerifyPhoneNumberClick}
                            visible={showVerificationPhoneNumber}
                        />
                    </div>
                    {/* <div style={{paddingTop: "5px" }}>
                        <b><span style={{fontSize:"12px"}}>Dropbox Connection: </span></b>
                        <Button
                            key='btnDropbox'
                            width={100}
                            height={30}
                            text={dropboxStatus}
                            type='default'
                            stylingMode='contained'
                            onClick={this.onDropboxClick}
                        />
                    </div> */}
                    <br/>
                    <Button
                        key='btnUpdate'
                        width={80}
                        height={30}
                        text='Update'
                        type='default'
                        stylingMode='contained'
                        onClick={this.onClick}
                    />


                    <Popup
                        className={'popup'}
                        visible={this.state.popupVisible}
                        onHiding={this.hidePopup}
                        dragEnabled={false}
                        closeOnOutsideClick={false}
                        showTitle={true}
                        title={'Phone number verification'}
                        width={300}
                        height={150}
                    >
                        <div style={{textAlign:"center", paddingTop:"20px"}}>
                            <TextBox placeholder={'Enter code here...'} onValueChanged={this.valueChanged} />
                            <br/>
                            <Button
                                key='btnVerify'
                                width={80}
                                height={30}
                                text='Verify'
                                type='default'
                                stylingMode='contained'
                                onClick={this.onVerifyClick}
                            />
                        </div>
                    </Popup>
                </div>
            </div>  
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Admin/UserProfile.js